import moment from 'moment';

export const getSeasonStartYear = (value, colla) => {
    if (value === undefined || value === null || value === '') return null;

    const date = moment.isMoment(value) || value instanceof Date
        ? moment(value)
        : moment(value, moment.ISO_8601, true);
    if (!date.isValid()) return null;

    if (colla === 'sarri') return date.year();

    return date.month() >= 8 ? date.year() : date.year() - 1;
};

export const getAvailableSeasonYears = (events, colla, now = moment()) => {
    const currentSeasonYear = getSeasonStartYear(now, colla);

    return [...new Set(
        events
            .map(event => getSeasonStartYear(event['data-esperada-inici'], colla))
            .filter(year => year !== null && year <= currentSeasonYear)
    )].sort((a, b) => b - a);
};
